// Configure these when the GoDiGo app / store listings go live.
// Set values in /app/frontend/.env (REACT_APP_*) or edit the fallbacks below.
export const LINKS = {
  appUrl: process.env.REACT_APP_GODIGO_APP_URL || "",
  playStoreUrl: process.env.REACT_APP_PLAY_STORE_URL || "",
  appStoreUrl: process.env.REACT_APP_APP_STORE_URL || "",
};

export const isConfigured = (url) => Boolean(url && url.trim());
